import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.scss';
import App from './app';
import reportWebVitals from './reportWebVitals';
import store from './store/';
ReactDOM.render(/*#__PURE__*/ React.createElement(Provider, {
    store: store
}, /*#__PURE__*/ React.createElement(App, null)), document.getElementById('root'));
reportWebVitals();
